import React from "react";
import { Provider } from "react-redux";
import store, { history } from "../store/configureStore";
import { ConnectedRouter } from "connected-react-router";
import _ from "lodash";

import useDimensions from "../services/useDimesion";
import GlobalStyle from "../globalStyles";

import AppRoutes from "./AppRoutes";

const AppContainer = () => {
  useDimensions();
  return (
    <Provider store={store}>
      <GlobalStyle />
      <ConnectedRouter history={history}>
        <AppRoutes />
      </ConnectedRouter>
    </Provider>
  );
};

export default AppContainer;
